import { render, staticRenderFns } from "./base-radio.vue?vue&type=template&id=0de178c1"
import script from "./base-radio.vue?vue&type=script&setup=true&lang=js"
export * from "./base-radio.vue?vue&type=script&setup=true&lang=js"
import style0 from "./base-radio.vue?vue&type=style&index=0&id=0de178c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports